import React from 'react';
import enhance from './enhance';
import styles from '../Template/styles.module.scss';
import PriorityLabel from '../Template/PriorityLabel';
import Charm from '../Charm';
import DesignOptions from 'components/SeriesDetail/DesignOptions';
import MiniSecondaryOption from 'components/SeriesDetail/MiniSecondaryOption';

export const TemplateViewOnly = ({
  formattedDesignPrice,
  formattedTotal,
  onClickOrTouch,
  formattedPriceBand,
  selectedDesignOption,
  submittedTemplatePriority,
  submittedTemplateQuantity,
  suggestedQuant,
  designPackageForTemplate,
  templateId,
  charmsForTemplate,
  mini,
  expand,
  collapse,
  expanded,
  primaryOptions,
  secondaryOptions,
}) => (
  <div className={styles.templateView}>
    <div className={styles.template}>
      <span className={styles.selectedOptions}>
        <DesignOptions
          designPackage={designPackageForTemplate}
          onClickOrTouch={onClickOrTouch}
          selectedDesignOption={selectedDesignOption}
          isDuplicate={'false'}
          templateId={templateId}
          mini={mini}
          expand={expand}
          primaryOptions={primaryOptions}
          secondaryOptions={secondaryOptions}
        />
        <span className={styles.designPrice}>+ {formattedDesignPrice}</span>
      </span>
      <span className={styles.priceBand}>({formattedPriceBand})</span>
      <span className={styles.totalPrice}>{formattedTotal}</span>
      <span className={styles.suggestedQuant}>{suggestedQuant}</span>
      <span className={styles.charms}>
        {charmsForTemplate.map(charm => (
          <Charm charm={charm} detail={false} />
        ))}
      </span>
      <span className={styles.selectedQuantityStatic}>
        {submittedTemplateQuantity}
      </span>
      <span className={styles.priority}>
        <PriorityLabel priority={submittedTemplatePriority} />
      </span>
      <span className={styles.skinnyColumn} />
      <span className={styles.buttonColumn} />
      <span />
    </div>

    {mini && expanded && (
      <div className={styles.secondaryOptions} onClick={collapse}>
        <div className={styles.secondaryOptionsInner}>
          <span className={styles.options}>
            {secondaryOptions.map(optionKey => (
              <MiniSecondaryOption
                key={optionKey}
                optionKey={optionKey}
                designPackage={designPackageForTemplate}
              />
            ))}
          </span>
        </div>
        <div className={styles.outerArea} onClick={collapse} />
      </div>
    )}
  </div>
);

export default enhance(TemplateViewOnly);
